import { useForm, ValidationError } from "@formspree/react";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";

const RECAPTCHA_SITE_KEY = "6Lf9QEorAAAAAN-Ko3ujb0Q82aKf27oTD-t8vW0U"; // Replace with your reCAPTCHA v2 site key

export default function WaitlistModal({ isOpen, onClose }) {
  const [state, handleSubmit] = useForm("xvganeqq"); // Replace with your Formspree ID
  const [captcha, setCaptcha] = useState("");

  // Custom submit handler to enforce reCAPTCHA before submitting
  function customHandleSubmit(event) {
    if (!captcha) {
      event.preventDefault();
      alert("Please complete the reCAPTCHA.");
      return;
    }
    handleSubmit(event);
  }

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl p-8 shadow-lg w-full max-w-lg relative"
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-xl"
        >
          ×
        </button>
        {state.succeeded ? (
          <div className="text-center py-10">
            <h2 className="text-3xl font-bold text-blue-600 mb-4">Thank you!</h2>
            <p className="text-gray-700">
              You’re on the waitlist! We’ll be in touch soon.
            </p>
          </div>
        ) : (
          <>
            <h2 className="text-2xl font-bold text-center mb-2">
              Join the Waitlist
            </h2>
            <p className="text-gray-500 font-bold text-center mb-6">
              Sign up for early access and updates. No spam—just product news.
            </p>
            <form onSubmit={customHandleSubmit} className="space-y-6">
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-600" htmlFor="modalName">
                  Full Name
                </label>
                <input
                  className="w-full px-4 py-3 rounded-full bg-gray-100 font-bold outline-none focus:ring-2 focus:ring-blue-200"
                  id="modalName"
                  type="text"
                  name="name"
                  required
                />
                <ValidationError prefix="Name" field="name" errors={state.errors} />
              </div>
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-600" htmlFor="modalEmail">
                  Email Address
                </label>
                <input
                  className="w-full px-4 py-3 rounded-full bg-gray-100 font-bold outline-none focus:ring-2 focus:ring-blue-200"
                  id="modalEmail"
                  type="email"
                  name="email"
                  required
                />
                <ValidationError prefix="Email" field="email" errors={state.errors} />
              </div>
              {/* reCAPTCHA widget */}
              <div>
                <ReCAPTCHA
                  sitekey={RECAPTCHA_SITE_KEY}
                  onChange={setCaptcha}
                />
                {/* Hidden field for Formspree to read the token */}
                <input type="hidden" name="g-recaptcha-response" value={captcha} />
              </div>
              <button
                type="submit"
                disabled={state.submitting}
                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 rounded-full transition"
              >
                {state.submitting ? "Joining..." : "Join Waitlist"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
